// Marca Redactia: triángulo sólido azul marino + triángulo turquesa de la línea gráfica
// de Agencia Multimedios Sociedad de la Información, SRL.
export const LogoMark = ({ className = "h-8 w-8", navy = "#013060", turquoise = "#52DDCF" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Redactia">
    <polygon points="34,6 34,58 8,32" fill="none" stroke={turquoise} strokeWidth="4" />
    <polygon points="30,8 56,32 30,56" fill={navy} />
    <polygon points="30,26 38,32 30,38" fill={turquoise} />
  </svg>
);

export const Logo = ({ compact = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
    <LogoMark className="h-9 w-9 shrink-0" />
    <div className="min-w-0">
      <div className="serif text-2xl font-bold leading-none tracking-tight text-foreground">
        Redactia
      </div>
      {!compact && (
        <div className="text-[10px] uppercase tracking-[0.18em] text-primary mt-1 leading-tight">
          Sala de redacción inteligente
        </div>
      )}
    </div>
  </div>
);
